/** The selected business's IANA timezone from the accessible-business list. */
export function businessTimezoneOf(
  businesses: Array<Record<string, unknown>>,
  businessId: string | null | undefined,
): string | undefined {
  if (!businessId) return undefined;
  const hit = businesses.find((b) => String(b.id ?? b.businessId ?? "") === businessId);
  const tz = typeof hit?.timezone === "string" ? hit.timezone.trim() : "";
  return tz || undefined;
}
